import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";
import { customFieldValues } from "../../custom_fields";

export const workOrderStatus = v.union(
  v.literal("draft"),
  v.literal("scheduled"),
  v.literal("in_progress"),
  v.literal("completed"),
  v.literal("cancelled"),
);

export const validatorWorkOrder = v.object({
  code: v.optional(v.string()),
  title: v.optional(v.string()),
  description: v.optional(v.string()),

  clientId: v.optional(v.id("clients")),
  quotationId: v.optional(v.id("quotations")),
  saleId: v.optional(v.id("sales")),
  invoiceId: v.optional(v.id("invoices")),
  serviceId: v.optional(v.id("services")),

  status: v.optional(workOrderStatus),
  priority: v.optional(
    v.union(
      v.literal("low"),
      v.literal("medium"),
      v.literal("high"),
      v.literal("urgent"),
    ),
  ),

  scheduledDate: v.optional(v.number()),
  startDate: v.optional(v.number()),
  endDate: v.optional(v.number()),
  estimatedDuration: v.optional(v.number()),

  location: v.optional(v.string()),
  address: v.optional(v.string()),
  coordinates: v.optional(
    v.object({
      lat: v.number(),
      lng: v.number(),
    }),
  ),

  clientRequirements: v.optional(v.any()),
  notes: v.optional(v.string()),

  totalCost: v.optional(v.number()),
  totalBilled: v.optional(v.number()),

  internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});

export const work_orders = defineTableWithInternalControl(validatorWorkOrder)
  .index("by_code", ["code"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_client", ["clientId"])
  .index("by_quotation", ["quotationId"])
  .index("by_sale", ["saleId"])
  .index("by_invoice", ["invoiceId"])
  .index("by_service", ["serviceId"])
  .index("by_status", ["status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_branch_and_status", ["internalControl.branchId", "status"])
  .index("by_company_and_client", ["internalControl.companyId", "clientId"])
  .index("by_branch_and_client", ["internalControl.branchId", "clientId"])
  .index("by_scheduled_date", ["scheduledDate"])
  // Dashboard: rango de fechas dentro de una sucursal sin traer toda la sucursal.
  .index("by_company_and_branch_and_created_at", [
    "internalControl.companyId",
    "internalControl.branchId",
    "internalControl.createdAt",
  ])
  .searchIndex("search_work_orders", {
    searchField: "title",
    filterFields: [
      "internalControl.companyId",
      "internalControl.branchId",
      "status",
    ],
  });
